import { AxiosError, isAxiosError, isCancel } from 'axios'

import { AppError } from './AppError'
import { ErrorCode } from './ErrorCode'

/** Explicit `boolean` return type, otherwise it casts the call site tp AppError */
export function isAbortError(error: unknown): boolean {
	return (
		isCancel(error) ||
		(isAxiosError(error) && error.code === AxiosError.ECONNABORTED) ||
		(error instanceof DOMException && (error.name === 'AbortError' || error.name === 'TimeoutError')) ||
		AppError.is(error, ErrorCode.cancelled)
	)
}
